import type { VoiceProvider } from "@/hooks/api/use-voice-providers";

/**
 * The providers on offer, plus the one this voice already names if it is no longer among them.
 *
 * A plugin can be removed from a workspace after a voice was curated against it, and the row still
 * has to be openable, renameable and retirable — a select that silently drops the value it was
 * given edits the record by being looked at.
 *
 * Why it is missing is the caller's to say, and it matters: a plugin that is not set up here, a
 * plugin list that could not be read at all, and no workspace selected are three different things
 * to go and do, and only one of them is about this plugin.
 */
export function withCurrentProvider(
	configured: VoiceProvider[],
	current: string | null | undefined,
	reason: string
): VoiceProvider[] {
	if (!current || configured.some((provider) => provider.key === current)) return configured;

	return [
		...configured,
		{
			key: current,
			title: current,
			voiceCount: 0,
			canListVoices: false,
			// An id it already has and we cannot check. Asking for it back is the only honest
			// control: there is no catalogue to pick from and no plugin to speak through.
			requiresVoiceId: true,
			canSynthesise: false,
			reason,
		},
	];
}
